import React from 'react';
import { FormattedMessage } from 'react-intl';

export default class EditEntityId extends React.Component {

    constructor(props) {
        super(props);

        this.state = {uniqueId: this.props.uniqueThirdPartyId ? this.props.uniqueThirdPartyId : ''};

        this.changeUniqueId = this.changeUniqueId.bind(this);

        this.blurAction = this.blurAction.bind(this);
    }

    changeUniqueId(event) {
        let newTitle = event.target.value;

        this.setState({
            uniqueId: newTitle
        });
    }

    blurAction() {
        if (this.props.uniqueThirdPartyId !== this.state.uniqueId) {
            this.props.onBlur("uniqueThirdPartyId", this.state.uniqueId);
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.uniqueThirdPartyId !== this.props.uniqueThirdPartyId) {
            this.setState({uniqueId: nextProps.uniqueThirdPartyId ? nextProps.uniqueThirdPartyId : ''})
        }
    }


    render() {
        return (
            <div className="edit-third-party__about__input-group">
                <div className="row-label">
                    <label className="row-label" htmlFor="edit-third-party__about__company-id">
                        <FormattedMessage id="Entities_Edit_UIText_editThirdParty.companyIdLabel" />
                    </label>
                </div>
                <input type="text"
                       id="edit-third-party__about__company-id"
                       name="companyId"
                       value={this.state.uniqueId}
                       onChange={this.changeUniqueId}
                       onBlur={this.blurAction} />
            </div>
        );
    }

}



// WEBPACK FOOTER //
// ./src/scripts/pages/EditThirdParty/components/EditEntityId.jsx